import { AnyAction } from "@reduxjs/toolkit";
import {
    CHANGE_DATES,
    CHANGE_STATION,
    CLEAR_FETCHING_DATA_FAILED,
    CLOSE_BOOKING_INFO,
    CLOSE_STATION_INFO,
    CLOSE_VEHICLE_INFO,
    COMPILE_DISPOSITION_DATA,
    SET_SINGLE_DAY_PREVIOUS_STARTDATE,
    DISPOSITION_INITIALIZE_SAGA,
    DISPOSITION_SET_DEFAULT_VALUES,
    DISPOSITION_SET_FILTER,
    FETCHING_DATA_FAILED,
    FETCHING_DATA_START,
    INITIALIZE_FAILED,
    INITIALIZE_SUCCESS,
    OPEN_BOOKING_INFO,
    OPEN_STATION_INFO,
    OPEN_VEHICLE_INFO,
    RENDER,
    TOGGLE_ARRIVING_VEHICLES,
    TOGGLE_STATION,
    TOGGLE_VEHICLES_IN_STATION,
    TOGGLE_HIDE_UNAVAILABLE_VEHICLES,
    DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER,
    CLEAR,
    CLEAR_DATA,
    RESERVATION_LOG_INITIALIZE_SAGA,
    FETCHING_RESERVATION_LOG_DATA_START,
    FETCHING_RESERVATION_LOG_DATA,
    FETCHING_RESERVATION_LOG_DATA_SUCCESS,
    CHANGE_SHOWBEFORE_RESERVATION_LOG_START,
    CHANGE_SHOWBEFORE_RESERVATION_LOG,
    CHANGE_SHOWAFTER_RESERVATION_LOG_START,
    CHANGE_SHOWAFTER_RESERVATION_LOG,
    CHANGE_ALLSTATIONS_RESERVATION_LOG,
    CHANGE_ALLSTATIONS_RESERVATION_LOG_START,
    CLEAR_RESERVATION_LOG_DATA,
    FETCHING_RESERVATION_LOG_DATA_FAILED,
    CLEAR_FETCHING_RESERVATION_LOG_DATA_FAILED,
    CHANGE_DELIVERY_VEHICLE_LOG,
    CHANGE_PICKUPCONFIRMED_VEHICLE_LOG,
    CHANGE_PICKUPPLANNED_VEHICLE_LOG,
    CHANGE_FROMSTATION_VEHICLE_LOG,
    CHANGE_TOSTATION_VEHICLE_LOG,
    CHANGE_WITHOUTDELIVERED_VEHICLE_LOG,
    VEHICLE_LOG_INITIALIZE_SAGA,
    FETCHING_VEHICLE_LOG_DATA_SUCCESS,
    CHANGE_ALLSTATIONS_VEHICLE_LOG,
    CHANGE_SHOWBEFORE_VEHICLE_LOG,
    CHANGE_SHOWAFTER_VEHICLE_LOG,
    CLEAR_VEHICLE_LOG_DATA,
    CHANGE_SHOWAFTER_VEHICLE_LOG_START,
    CHANGE_SHOWBEFORE_VEHICLE_LOG_START,
    FETCH_BOOKING_SUCCESS
} from "@/Redux/Disposition/Constants";
import { RootStateOrAny } from "react-redux";

interface DispositionState {
    fetchingDataIsFailed: boolean;
    rawData: any;
    initialized: boolean;
    isInitializing: boolean;
    reservationLogInitialized: boolean;
    isReservationLogInitializing: boolean;
    isFetchingData: boolean;
    data: any;
    reservationLogData: any;
    dispositionStartdate: string | null;
    dispositionEnddate: string | null;
    days: number;
    hours: number;
    dispoWidth: number;
    dayWidth: number;
    singleDay: number;
    dispositionBodyMarginTop: string;
    dispositionBodyHeight: string;
    selectedStation: string | null;
    showOnlyGroupResOfStationFilter: any;
    stationFilter: any;
    vehicleGroupFilter: any;
    regionFilter: any;
    categoryFilter: any;
    equipmentFilter: any;
    hideVehiclesInStations: any;
    hiddenStations: any;
    latestFetchedStartdate: string | null;
    latestFetchedEnddate: string | null;
    singleDayPreviousStartdate: string | null;
    dispositionControlsHeight: number;
    dispositionControlsTop: number;
    headerTop: number;
    headerHeight: number;
    vehicleInfoOverlayItem: any;
    bookingInfoOverlayItem: any;
    stationInfoOverlayItem: any;
    showArrivingVehicles: boolean;
    hideUnavailableVehicles: any;
    fetchingReservationLogDataIsFailed: boolean;
    isFetchingReservationLogData: boolean;
    allStations: boolean;
    showBefore: boolean;
    showAfter: boolean;
    logInitialized: boolean;
    isLogInitializing: boolean;
    logData: any;
    delivery: boolean,
    pickupPlanned: boolean,
    pickupConfirmed: boolean,
    fromStation: boolean,
    toStation: boolean,
    withoutDelivered: boolean,
    fetchingLogDataIsFailed: boolean,
    isFetchingLogData: boolean,
    lastBookingContractColor: string,
    lastBookingHasVehicle: boolean
}

const initialState: DispositionState = {
    fetchingDataIsFailed: false,
    rawData: null,
    initialized: false,
    isInitializing: false,
    reservationLogInitialized: false,
    isReservationLogInitializing: false,
    isFetchingData: false,
    data: null,
    reservationLogData: null,
    dispositionStartdate: null,
    dispositionEnddate: null,
    days: 0,
    hours: 24,
    dispoWidth: 0,
    dayWidth: 0,
    singleDay: 1,
    dispositionBodyMarginTop: "",
    dispositionBodyHeight: "",
    selectedStation: localStorage.getItem("CRENT_WEB/SELECTED_STATION") || null,
    showOnlyGroupResOfStationFilter:
        sessionStorage.getItem("CRENT_WEB/ONLY_GROUP_RES_OF_STATION") || false,
    stationFilter:
        JSON.parse(
            sessionStorage.getItem("CRENT_WEB/STATION_FILTER") as string,
        ) || [],
    vehicleGroupFilter:
        JSON.parse(
            sessionStorage.getItem("CRENT_WEB/VEHICLE_GROUP_FILTER") as string,
        ) || [],
    regionFilter:
        JSON.parse(
            sessionStorage.getItem("CRENT_WEB/REGION_FILTER") as string,
        ) || [],
    categoryFilter:
        JSON.parse(
            sessionStorage.getItem("CRENT_WEB/CATEGORY_FILTER") as string,
        ) || [],
    equipmentFilter:
        JSON.parse(
            sessionStorage.getItem("CRENT_WEB/EQUIPMENT_FILTER") as string,
        ) || [],
    hideVehiclesInStations: [],
    hiddenStations: [],
    latestFetchedStartdate: null,
    latestFetchedEnddate: null,
    singleDayPreviousStartdate: null,
    dispositionControlsHeight: 0,
    dispositionControlsTop: 0,
    headerTop: 0,
    headerHeight: 0,
    vehicleInfoOverlayItem: null,
    bookingInfoOverlayItem: null,
    stationInfoOverlayItem: null,
    showArrivingVehicles: true,
    hideUnavailableVehicles: [],
    fetchingReservationLogDataIsFailed: false,
    isFetchingReservationLogData: false,
    allStations: false,
    showBefore: false,
    showAfter: false,
    logInitialized: false,
    isLogInitializing: false,
    logData: null,
    delivery: false,
    pickupPlanned: false,
    pickupConfirmed: false,
    fromStation: false,
    toStation: false,
    withoutDelivered: false,
    fetchingLogDataIsFailed: false,
    isFetchingLogData: false,
    lastBookingContractColor: "",
    lastBookingHasVehicle: false
};

export default function DispositionReducer(
    state = initialState,
    action: AnyAction,
) {
    switch (action.type) {
        case DISPOSITION_INITIALIZE_SAGA:
            return { ...state, isInitializing: true, data: null };
        case VEHICLE_LOG_INITIALIZE_SAGA:
            return {...state, isLogInitializing: true, logData: null}
        case RESERVATION_LOG_INITIALIZE_SAGA:
            return {
                ...state,
                isReservationLogInitializing: true,
                reservationLogData: null,
            };
        case INITIALIZE_SUCCESS:
            return {
                ...state,
                initialized: true,
                isInitializing: false,
                logInitialized: true,
                isLogInitializing: false,
                reservationLogInitialized: true,
                isReservationLogInitializing: false,
            };
        case DISPOSITION_SET_DEFAULT_VALUES:
            localStorage.setItem(
                "CRENT_WEB/SELECTED_STATION",
                action.payload.selectedStation,
            );
            return {
                ...state,
                dispositionStartdate: action.payload.dispositionStartdate,
                dispositionEnddate: action.payload.dispositionEnddate,
                days: action.payload.days,
                dayWidth: action.payload.dayWidth,
                hours: action.payload.hours,
                selectedStation: action.payload.selectedStation,
                allStations: false,
                delivery: false,
                pickupPlanned: false,
                pickupConfirmed: false,
                fromStation: false,
                toStation: false,
                withoutDelivered: false,
            };
        case FETCHING_VEHICLE_LOG_DATA_SUCCESS:
            return {
                ...state,
                logData: action.payload.vehicleLogList
            }
        case FETCHING_RESERVATION_LOG_DATA_SUCCESS:
            return {
                ...state,
                reservationLogData: action.payload.reservationLogList,
                isFetchingReservationLogData: false,
            };
        case FETCHING_DATA_START:
            return {
                ...state,
                isFetchingData: true,
                data: null,
                rawData: null,
                latestFetchedStartdate: action.payload.dispositionStartdate,
                latestFetchedEnddate: action.payload.dispositionEnddate,
                fetchingDataIsFailed: false,
            };
        case FETCHING_RESERVATION_LOG_DATA_START:
            return {
                ...state,
                isFetchingReservationLogData: true,
                rawData: null,
                reservationLogData: null,
                latestFetchedStartdate: action.payload.dispositionStartdate,
                latestFetchedEnddate: action.payload.dispositionEnddate,
                fetchingReservationLogDataIsFailed: false,
            };
        case SET_SINGLE_DAY_PREVIOUS_STARTDATE:
            return {
                ...state,
                singleDayPreviousStartdate: action.payload.singleDayPreviousStartdate
            };
        case COMPILE_DISPOSITION_DATA:
            return {
                ...state,
                rawData: action.data,
            };
        case FETCH_BOOKING_SUCCESS:
            return {
                ...state,
                lastBookingContractColor: action.data[0],
                lastBookingHasVehicle: action.data[1]
            };
        case RENDER:
            return {
                ...state,
                isFetchingData: false,
                data: action.data,
                isFetchingReservationLogData: false,
                reservationLogData: null,
            };
        case FETCHING_DATA_FAILED:
            return {
                ...state,
                isFetchingData: false,
                data: [],
                fetchingDataIsFailed: true,
            };
        case FETCHING_RESERVATION_LOG_DATA_FAILED:
            return {
                ...state,
                isFetchingReservationLogData: false,
                reservationLogData: [],
                fetchingReservationLogDataIsFailed: true,
            };
        case INITIALIZE_FAILED:
            return {
                ...state,
                initialized: false,
                isInitializing: false,
                logInitialized: false,
                isLogInitializing: false,
                reservationLogInitialized: false,
                isReservationLogInitializing: false,
            };
        case CLEAR_FETCHING_DATA_FAILED:
            return {
                ...state,
                fetchingDataIsFailed: false,
            };
        case CLEAR_FETCHING_RESERVATION_LOG_DATA_FAILED:
            return {
                ...state,
                fetchingReservationLogDataIsFailed: false,
            };
        case CHANGE_STATION:
            localStorage.setItem("CRENT_WEB/SELECTED_STATION", action.data);
            return {
                ...state,
                selectedStation: action.data,
                data: null,
                reservationLogData: null
            };
        case CHANGE_DATES:
            return {
                ...state,
                dispositionStartdate: action.data.dispositionStartdate,
                dispositionEnddate: action.data.dispositionEnddate,
                hours: action.data.hours,
                days: action.data.days,
                dayWidth: action.data.dayWidth,
                singleDay: action.data.singleDay,
            };
        case DISPOSITION_SET_FILTER:
            localStorage.setItem(
                "CRENT_WEB/ONLY_GROUP_RES_OF_STATION",
                action.data.showOnlyGroupResOfStationFilter,
            );
            localStorage.setItem(
                "CRENT_WEB/STATION_FILTER",
                JSON.stringify(action.data.stationFilter),
            );
            localStorage.setItem(
                "CRENT_WEB/VEHICLE_GROUP_FILTER",
                JSON.stringify(action.data.vehicleGroupFilter),
            );
            localStorage.setItem(
                "CRENT_WEB/REGION_FILTER",
                JSON.stringify(action.data.regionFilter),
            );
            localStorage.setItem(
                "CRENT_WEB/CATEGORY_FILTER",
                JSON.stringify(action.data.categoryFilter),
            );
            localStorage.setItem(
                "CRENT_WEB/EQUIPMENT_FILTER",
                JSON.stringify(action.data.equipmentFilter),
            );

            return {
                ...state,
                showOnlyGroupResOfStationFilter:
                    action.data.showOnlyGroupResOfStationFilter,
                stationFilter: action.data.stationFilter,
                vehicleGroupFilter: action.data.vehicleGroupFilter,
                regionFilter: action.data.regionFilter,
                categoryFilter: action.data.categoryFilter,
                equipmentFilter: action.data.equipmentFilter,
            };
        case TOGGLE_STATION:
            let toggledStations = state.hiddenStations.slice();
            if (toggledStations.indexOf(action.data.stationId) <= -1) {
                toggledStations.push(action.data.stationId);
            } else {
                toggledStations = toggledStations.filter(function (
                    value: string,
                    index: number,
                    arr: any,
                ) {
                    return value !== action.data.stationId;
                });
            }
            return {
                ...state,
                hiddenStations: toggledStations,
            };
        case TOGGLE_VEHICLES_IN_STATION:
            let toggledVehiclesInStation = state.hideVehiclesInStations.slice();
            if (toggledVehiclesInStation.indexOf(action.data.stationId) <= -1) {
                toggledVehiclesInStation.push(action.data.stationId);
            } else {
                toggledVehiclesInStation = toggledVehiclesInStation.filter(
                    function (value: string, index: number, arr: any) {
                        return value !== action.data.stationId;
                    },
                );
            }
            return {
                ...state,
                hideVehiclesInStations: toggledVehiclesInStation,
            };
        case TOGGLE_HIDE_UNAVAILABLE_VEHICLES:
            let toggledUnavailableVehicleStations =
                state.hideUnavailableVehicles.slice();
            if (
                toggledUnavailableVehicleStations.indexOf(
                    action.data.stationId,
                ) <= -1
            ) {
                toggledUnavailableVehicleStations.push(action.data.stationId);
            } else {
                toggledUnavailableVehicleStations =
                    toggledUnavailableVehicleStations.filter(function (
                        value: string,
                        index: number,
                        arr: any,
                    ) {
                        return value !== action.data.stationId;
                    });
            }
            return {
                ...state,
                hideUnavailableVehicles: toggledUnavailableVehicleStations,
            };
        case OPEN_VEHICLE_INFO:
            return {
                ...state,
                vehicleInfoOverlayItem: action.data.item,
            };
        case OPEN_STATION_INFO:
            return {
                ...state,
                stationInfoOverlayItem: action.data.item,
            };
        case OPEN_BOOKING_INFO:
            return {
                ...state,
                bookingInfoOverlayItem: action.data.item,
            };
        case CLOSE_VEHICLE_INFO:
            return {
                ...state,
                vehicleInfoOverlayItem: null,
            };
        case CLOSE_STATION_INFO:
            return {
                ...state,
                stationInfoOverlayItem: null,
            };
        case CLOSE_BOOKING_INFO:
            return {
                ...state,
                bookingInfoOverlayItem: null,
            };
        case TOGGLE_ARRIVING_VEHICLES:
            return {
                ...state,
                showArrivingVehicles: !state.showArrivingVehicles,
            };
        case DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER:
            return {
                ...state,
                showOnlyGroupResOfStationFilter: true,
            };
        case CLEAR:
            return {
                ...initialState,
            };
        case CLEAR_DATA:
            return {
                ...state,
                data: null,
            };
        case CLEAR_VEHICLE_LOG_DATA:
            return {
                ...state,
                logData: null,
            };
        case CLEAR_RESERVATION_LOG_DATA:
            return {
                ...state,
                reservationLogData: null,
            };
        case CHANGE_ALLSTATIONS_RESERVATION_LOG:
            return {
                ...state,
                allStations: action.data.allStations,
            };
        case CHANGE_SHOWBEFORE_RESERVATION_LOG:
            return {
                ...state,
                showBefore: action.data.showBefore,
            };
        case CHANGE_SHOWAFTER_RESERVATION_LOG:
            return {
                ...state,
                showAfter: action.data.showAfter,
            };
        case CHANGE_DELIVERY_VEHICLE_LOG:
            return {
                ...state,
                delivery: action.data.delivery
            }
        case CHANGE_PICKUPCONFIRMED_VEHICLE_LOG:
            return {
                ...state,
                pickupConfirmed: action?.data?.pickupConfirmed
            }
        case CHANGE_PICKUPPLANNED_VEHICLE_LOG:
            return {
                ...state,
                pickupPlanned: action.data.pickupPlanned
            }
        case CHANGE_FROMSTATION_VEHICLE_LOG:
            return {
                ...state,
                fromStation: action.data.fromStation
            }
        case CHANGE_TOSTATION_VEHICLE_LOG:
            return {
                ...state,
                toStation: action.data.toStation
            }
        case CHANGE_WITHOUTDELIVERED_VEHICLE_LOG:
            return {
                ...state,
                withoutDelivered: action.data.withoutDelivered
            }
        case CHANGE_ALLSTATIONS_VEHICLE_LOG:
            return {
                ...state,
                allStations: action.data.allStations
            }
        case CHANGE_SHOWBEFORE_VEHICLE_LOG:
            return {
                ...state,
                showBefore: action.data.showBefore
            }
        case CHANGE_SHOWAFTER_VEHICLE_LOG:
            return {
                ...state,
                showAfter: action.data.showAfter
            }
        default:
            return state;
    }
}

export const getState = (state: RootStateOrAny) => {
    if (typeof state.disposition === "object") {
        return state.disposition;
    }
    return state;
};

export const selectData = (state: RootStateOrAny) => {
    return getState(state).data;
};

export const selectLogData = (state: RootStateOrAny) => {
    return getState(state).logData;
};

export const selectReservationLogData = (state: RootStateOrAny) => {
    return getState(state).reservationLogData;
};

export const selectLastBookingContractColor = (state: RootStateOrAny) => {
    return getState(state).lastBookingContractColor;
};

export const selectLastBookingHasVehicle = (state: RootStateOrAny) => {
    return getState(state).lastBookingHasVehicle;
};

export const selectHiddenStations = (state: RootStateOrAny) => {
    return getState(state).hiddenStations;
};

export const selectHideVehiclesInStations = (state: RootStateOrAny) => {
    return getState(state).hideVehiclesInStations;
};

export const selectShowArrivingVehicles = (state: RootStateOrAny) => {
    return getState(state).showArrivingVehicles;
};

export const selectShowOnlyGroupResOfStation = (state: RootStateOrAny) => {
    return JSON.parse(getState(state).showOnlyGroupResOfStationFilter);
};

export const selectHideUnavailableVehicles = (state: RootStateOrAny) => {
    return getState(state).hideUnavailableVehicles;
};